// extracted by mini-css-extract-plugin
export default {"container":"AboutCard_container__e08md","card":"AboutCard_card__Em-6O","img":"AboutCard_img__PFjnf","heading":"AboutCard_heading__ix9+S","content":"AboutCard_content__HxCfX"};